import React from "react";
import "../../../css/Transparencia/informacion-publica.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const InformacionPublica = () => (
  <div className="info-publica-full-bg">
    <div className="info-publica-container">
      <h1>Pedido de acceso a la información pública</h1>
      <p>
        Existen dos vías para ingresar una solicitud de acceso a la información
        pública, en ambos casos es fácil y gratuito.
        <br />
        <br />
        En cumplimiento de la Ordenanza Municipal 55/2020 y el Decreto 171/2020,
        queda habilitado vía web la posibilidad de presentar solicitudes de
        acceso a la información.
      </p>
      <ul className="info-publica-list">
        <li>
          <FontAwesomeIcon icon={faPlus} className="info-publica-icon" />
          <strong>Online:</strong> <span> Iniciá el trámite – LOS PEDIDOS DEBEN
          INGRESAR AL EMAIL</span>
          <a href="mailto:info@ciudaddeoliva.gov.ar">
            info@ciudaddeoliva.gov.ar
          </a>
        </li>
        <li>
          <FontAwesomeIcon icon={faPlus} className="info-publica-icon" />
          <strong>Por escrito:</strong> En mesa de entrada del Palacio Municipal
          (Belgrano 292) de lunes a viernes de 07:30 a 12:30 hs.
        </li>
      </ul>
      <p>
        Podés presentar tu formulario de Solicitud de Acceso a la Información en
        las mesas de entradas habilitadas.
        <br />
        <br />
        En ambos casos es necesario que la solicitud ingresada cuente con la
        siguiente información:
      </p>
      <ul className="info-publica-list">
        <li>
          <FontAwesomeIcon icon={faPlus} className="info-publica-icon" />
          Nombre y Apellido
        </li>
        <li>
          <FontAwesomeIcon icon={faPlus} className="info-publica-icon" />
          Domicilio en Oliva o un correo electrónico donde se enviará la
          respuesta
        </li>
        <li>
          <FontAwesomeIcon icon={faPlus} className="info-publica-icon" />
          Un número de teléfono o celular para despejar dudas o hacer
          aclaraciones si es necesario.
        </li>
      </ul>
    </div>
  </div>
);

export default InformacionPublica;
